import React from 'react';
import styles from './EvaluationHeader.module.scss';
import { Switch } from 'components/UI/V3/Forms/Switch';
import DefaultHeader from 'components/UI/V3/DefaultHeader/DefaultHeader';

interface EvaluationHeaderProps {
    isEnabled: boolean;
    onToggleEnabled: (enabled: boolean) => void;
}

export const EvaluationHeader: React.FC<EvaluationHeaderProps> = ({ isEnabled, onToggleEnabled }) => {
    return (
        <div className={styles.header}>
            <div className={styles.headerContent}>
                <DefaultHeader title="Evaluation" />
                <Switch
                    checked={isEnabled}
                    onChange={checked => onToggleEnabled(checked)}
                ></Switch>
            </div>
        </div>
    );
};

export default EvaluationHeader;
